document.querySelectorAll('.js-video-bg').forEach((frame) => {
    const VIDEO = frame.querySelector('video');

    if (VIDEO.hasAttribute('loop') && VIDEO.hasAttribute('autoplay')) {
        VIDEO
            .play()
            .catch(() => {
                VIDEO.style.display = 'none';
            });
    }
});

// Slow down background autoplay videos for smoother presentation
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('video[data-video-autoplay]').forEach((video) => {
        video.playbackRate = 0.5;
    });
});
